import { stringsKo } from "./strings.ko.js";
import type { WebStrings } from "./strings.types.js";

export const strings: WebStrings = stringsKo;
